module.exports = __webpack_public_path__ + "static/DataStrategy_818virtual-17fc777c92e3a6b745cf96a779bdeafe.png";